import RenderUtil from './render-util';

/**
 * Layer editor on fabric JS API level
 *
 * triggers events to execute the same logic as if the customer interactively changed the layer to support custom ref constraints
 */
class LayerEditor {

    static moveX(layer, value) {
        layer._object.left += value;

        this.updateMoving(layer);
    }

    static moveY(layer, value) {
        layer._object.top += value;

        this.updateMoving(layer);
    }

    static scale(layer, value){
        layer._object.scaleX += value;
        layer._object.scaleY += value;

        this.updateScaling(layer);
    }

    static rotate(){
        /*
        center rotation is fucked    originX/Y cannot be changed
        https://github.com/fabricjs/fabric.js/issues/439#issuecomment-24029367
        https://stackoverflow.com/questions/52049159/fabric-js-rotate-object-around-canvas-center-smoothly
        https://jsfiddle.net/j0g1tLsb/74/
         */
    }

    static center(layer, axis){
        let dimensions = RenderUtil.getDimensions(layer._object);
        let refCoordinates = RenderUtil.getRefCoordinates(layer, layer._context);
        let refDimensions = RenderUtil.getRefDimensions(layer, layer._context);

        if(axis === 'h'){
            RenderUtil.centerHorizontal(layer._object, dimensions, refCoordinates, refDimensions);
        } else if(axis === 'v'){
            RenderUtil.centerVertical(layer._object, dimensions, refCoordinates, refDimensions);
        } else {
            RenderUtil.center(layer._object, dimensions, refCoordinates, refDimensions);
        }

        this.updateMoving(layer);
    }

    static updateMoving(layer){
        if(layer._canvas){
            layer._canvas.fire('object:moving', { target: layer._object });
            layer._canvas.fire('object:modified', { target: layer._object });
            layer._canvas.requestRenderAll();
        }
    }

    static updateScaling(layer){
        if(layer._canvas){
            // IMPORTANT: scaling only trigger when actually scaled (scaleX/Y changed)
            layer._canvas.fire('object:scaling', { target: layer._object });
            layer._canvas.fire('object:modified', { target: layer._object });
            layer._canvas.requestRenderAll();
        }
    }
}

export default LayerEditor;